__turbopack_context__.v({
  "flatDescription__amount": "PriceBlock-module-scss-module__uheNEa__flatDescription__amount",
  "flatDescription__discount": "PriceBlock-module-scss-module__uheNEa__flatDescription__discount",
  "flatDescription__discount__text": "PriceBlock-module-scss-module__uheNEa__flatDescription__discount__text",
  "flatDescription__price": "PriceBlock-module-scss-module__uheNEa__flatDescription__price",
  "icon": "PriceBlock-module-scss-module__uheNEa__icon",
  "tooltip": "PriceBlock-module-scss-module__uheNEa__tooltip",
  "tooltipArrow": "PriceBlock-module-scss-module__uheNEa__tooltipArrow",
});
